import { Injectable } from '@angular/core';
import { Subject, Observable, filter, map } from 'rxjs';

export interface AppEvent<T = unknown> {
  type: string;
  payload?: T;
}

export const APP_EVENTS = {
  PREFERENCES_SAVED:  'preferences:saved',
  TABLE_REFRESH:      'table:refresh',
  USER_LOGGED_OUT:    'user:loggedOut',
} as const;

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private eventBus = new Subject<AppEvent>();

  emit(type: string): void {
    this.eventBus.next({ type });
  }
  emitWithPayload<T>(type: string, payload: T): void {
    this.eventBus.next({ type, payload });
  }
  on(type: string): Observable<void> {
    return this.eventBus.asObservable().pipe(
      filter((event: any) => event.type === type),
      map(() => undefined)
    );
  }
  onWithPayload<T>(type: string): Observable<T> {
    return this.eventBus.asObservable().pipe(
      filter((event: any) => event.type === type),
      map((event: any) => event.payload as T)
    );
  }
}
